<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 180 162"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>home-decorators</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <circle
        id="path-1"
        cx="90"
        cy="90"
        r="90" />
    </defs>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-323.000000, -443.000000)">
        <g
          id="home-decorators"
          transform="translate(323.000000, 443.000000)">
          <mask
            id="mask-2"
            fill="white">
            <use xlink:href="#path-1" />
          </mask>
          <g
            id="Oval"
            fill-rule="nonzero" />
          <g
            id="Background"
            mask="url(#mask-2)">
            <g
              id="New_Symbol_77-34"
              transform="translate(-8.000000, -1.250000)">
              <g>
                <path
                  id="Path"
                  d="M188.000037,90.125 C187.996558,53.3703739 165.644038,20.3108915 131.536436,6.61512295 C97.4288349,-7.0806456 58.4203147,1.33956088 32.9989976,27.8849783 C7.57768042,54.4303956 0.852158994,93.7665353 16.01,127.25 L179.99,127.25 C185.280341,115.58894 188.011604,102.929995 188.000037,90.125 Z"
                  class="fill-extra-light"
                  fill-rule="nonzero" />
                <line
                  id="Path"
                  x1="10.25"
                  y1="127.25"
                  x2="185.75"
                  y2="127.25"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </g>
            </g>
          </g>
          <g
            id="Scene"
            mask="url(#mask-2)">
            <g
              id="Group"
              transform="translate(-8.000000, 15.750000)">
              <g>
                <rect
                  id="Rectangle"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  x="132.92"
                  y="9"
                  width="38.25"
                  height="42.75"
                  rx="2.25" />
                <rect
                  id="Rectangle"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  x="137.42"
                  y="13.5"
                  width="29.25"
                  height="33.75" />
                <path
                  id="Path"
                  d="M152,30.375 C152,25.875 161,24.75 161,32.625 C161,37.5975 152,41.625 152,41.625 C152,41.625 143,37.5975 143,32.625 C143,24.75 152,25.875 152,30.375 Z"
                  class="fill-light"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M145.25,19.125 C144.007359,19.125 143,20.1323593 143,21.375 C143,22.6176407 144.007359,23.625 145.25,23.625 C146.492641,23.625 147.5,22.6176407 147.5,21.375 C147.5,20.1323593 146.492641,19.125 145.25,19.125 Z"
                  fill="#0066A4"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M158.75,19.125 C157.507359,19.125 156.5,20.1323593 156.5,21.375 C156.5,22.6176407 157.507359,23.625 158.75,23.625 C159.992641,23.625 161,22.6176407 161,21.375 C161,20.1323593 159.992641,19.125 158.75,19.125 Z"
                  fill="#0066A4"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M179,67.5 L125,67.5 C122.514719,67.5 120.5,69.5147186 120.5,72 L120.5,110.25 L183.5,110.25 L183.5,72 C183.5,69.5147186 181.485281,67.5 179,67.5 Z"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M148.67,74.9025 C148.687947,73.8022416 147.907458,72.8504265 146.825,72.6525 C141.341687,71.7524732 135.748313,71.7524732 130.265,72.6525 C129.182542,72.8504265 128.402053,73.8022416 128.42,74.9025 L128.42,82.5975 C128.402053,83.6977584 129.182542,84.6495735 130.265,84.8475 C135.748313,85.7475268 141.341687,85.7475268 146.825,84.8475 C147.907458,84.6495735 148.687947,83.6977584 148.67,82.5975 L148.67,74.9025 Z"
                  class="stroke fill-light"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M175.67,74.9025 C175.687947,73.8022416 174.907458,72.8504265 173.825,72.6525 C168.341687,71.7524732 162.748313,71.7524732 157.265,72.6525 C156.182542,72.8504265 155.402053,73.8022416 155.42,74.9025 L155.42,82.5975 C155.402053,83.6977584 156.182542,84.6495735 157.265,84.8475 C162.748313,85.7475268 168.341687,85.7475268 173.825,84.8475 C174.907458,84.6495735 175.687947,83.6977584 175.67,82.5975 L175.67,74.9025 Z"
                  class="stroke fill-light"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M184.04,87.165 C184.08112,86.1318652 183.412833,85.2036888 182.42,84.915 C172.406075,82.9195768 162.209831,81.9844183 152,82.125 C141.801896,82.0141945 131.620554,82.9795365 121.625,85.005 C120.623216,85.2851488 119.944066,86.2154914 119.9825,87.255 L119.9825,91.125 L184.04,91.125 L184.04,87.165 Z"
                  class="stroke fill-light"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M183.5,91.125 L120.5,91.125 C119.257359,91.125 118.25,92.1323593 118.25,93.375 L118.25,110.25 L185.75,110.25 L185.75,93.375 C185.75,92.1323593 184.742641,91.125 183.5,91.125 Z"
                  class="fill-white"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M183.5,91.125 L120.5,91.125 C119.257359,91.125 118.25,92.1323593 118.25,93.375 L118.25,110.25 L185.75,110.25 L185.75,93.375 C185.75,92.1323593 184.742641,91.125 183.5,91.125 Z"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <rect
                  id="Rectangle"
                  class="fill-white"
                  fill-rule="nonzero"
                  x="91.295"
                  y="85.5"
                  width="22.5"
                  height="11.25"
                  rx="2.25" />
                <rect
                  id="Rectangle"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  x="91.295"
                  y="85.5"
                  width="22.5"
                  height="11.25"
                  rx="2.25" />
                <line
                  id="Path"
                  x1="95.795"
                  y1="96.75"
                  x2="93.545"
                  y2="110.25"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <line
                  id="Path"
                  x1="109.295"
                  y1="96.75"
                  x2="111.545"
                  y2="110.25"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <line
                  id="Path"
                  x1="94.445"
                  y1="105.75"
                  x2="110.645"
                  y2="105.75"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M99.17,76.5 L108.17,76.5 C109.412641,76.5 110.42,77.5073593 110.42,78.75 L110.42,85.5 L96.92,85.5 L96.92,78.75 C96.92,77.5073593 97.9273593,76.5 99.17,76.5 Z"
                  class="stroke fill-light"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M31.67,117 L0.17,117 L0.17,65.25 C0.17,64.0073593 1.17735931,63 2.42,63 L29.42,63 C30.6626407,63 31.67,64.0073593 31.67,65.25 L31.67,117 Z"
                  class="fill-white"
                  fill-rule="nonzero" />
                <circle
                  id="Oval"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  cx="35.045"
                  cy="77.625"
                  r="3.375" />
                <circle
                  id="Oval"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  cx="35.045"
                  cy="102.375"
                  r="3.375" />
                <path
                  id="Path"
                  d="M26.2475,128.250029 L25.82,128.250029 C24.6601743,128.255812 23.6859695,127.379028 23.57,126.225 L22.67,117 L29.42,117 L28.4975,126.225 C28.3815305,127.379028 27.4073257,128.255812 26.2475,128.250029 Z"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M5.9975,128.250029 L5.57,128.250029 C4.41017435,128.255812 3.43596946,127.379028 3.32,126.225 L2.42,117 L9.17,117 L8.2475,126.225 C8.13153054,127.379028 7.15732565,128.255812 5.9975,128.250029 Z"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M31.67,117 L0.17,117 L0.17,65.25 C0.17,64.0073593 1.17735931,63 2.42,63 L29.42,63 C30.6626407,63 31.67,64.0073593 31.67,65.25 L31.67,117 Z"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <ellipse
                  id="Oval"
                  class="fill-extra-light"
                  fill-rule="nonzero"
                  cx="67.6475"
                  cy="142.3575"
                  rx="25.875"
                  ry="3.8925" />
                <path
                  id="Path"
                  d="M84.5,53.01 L83.555,27.6975 L82.97,27.6975 C81.470308,34.8969213 75.125211,40.0564893 67.77125,40.0564893 C60.417289,40.0564893 54.072192,34.8969213 52.5725,27.6975 L51.9875,27.6975 L51.065,53.01 C51.0342879,53.7095549 51.2909082,54.391255 51.775308,54.8969004 C52.2597077,55.4025457 52.9297716,55.6881738 53.63,55.6875 L81.8,55.6875 C82.5214354,55.7193591 83.223361,55.4482855 83.7361221,54.9397975 C84.2488832,54.4313094 84.525821,53.7316768 84.5,53.01 L84.5,53.01 Z"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M85.7825,24.75 C85.7674137,23.2316362 84.6857521,21.9336423 83.195,21.645 L83.195,19.575 C83.195,11.0007793 76.2442207,4.05 67.67,4.05 C59.0957793,4.05 52.145,11.0007793 52.145,19.575 L52.145,21.645 C50.5882251,21.9400589 49.4878513,23.3385035 49.5672599,24.9210022 C49.6466684,26.5035008 50.8815079,27.7847664 52.46,27.9225 C53.959692,35.1219213 60.304789,40.2814893 67.65875,40.2814893 C75.012711,40.2814893 81.357808,35.1219213 82.8575,27.9225 C84.5022263,27.7724385 85.7662328,26.4014776 85.7825,24.75 Z"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M61.8425,19.4625 C61.0467435,19.4534048 60.3246833,19.926968 60.015944,20.6604468 C59.7072047,21.3939257 59.8732447,22.2413121 60.4359663,22.8040337 C60.9986879,23.3667553 61.8460743,23.5327953 62.5795532,23.224056 C63.313032,22.9153167 63.7865952,22.1932565 63.7775,21.3975 C63.7775,20.328829 62.911171,19.4625 61.8425,19.4625 Z"
                  fill="#0066A4"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M73.475,19.4625 C72.6812289,19.4625524 71.9660712,19.9419532 71.6644531,20.6761869 C71.3628351,21.4104206 71.5344758,22.254112 72.0989917,22.8121392 C72.6635076,23.3701664 73.5091268,23.5320424 74.2398247,23.2219565 C74.9705225,22.9118706 75.4416238,22.1912187 75.4325,21.3975 C75.4201739,20.3251996 74.5473712,19.4624292 73.475,19.4625 L73.475,19.4625 Z"
                  fill="#0066A4"
                  fill-rule="nonzero" />
                <circle
                  id="Oval"
                  class="fill-light"
                  fill-rule="nonzero"
                  cx="59.255"
                  cy="26.5725"
                  r="1.935" />
                <circle
                  id="Oval"
                  class="fill-light"
                  fill-rule="nonzero"
                  cx="76.0625"
                  cy="26.5725"
                  r="1.935" />
                <path
                  id="Path"
                  d="M63.7775,31.23 C66.1314559,32.7847288 69.1860441,32.7847288 71.54,31.23"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M75.23,1.35 C74.2436357,1.37082653 73.3619704,1.97035888 72.98,2.88 C73.6224309,3.80249583 73.9962988,4.88515507 74.06,6.0075 C74.1472542,7.94228766 73.7037591,9.86410002 72.7775,11.565 C72.7775,13.4325 78.425,19.2825 81.7775,21.7125 C82.150804,21.9805633 82.6390073,22.0283872 83.0572342,21.8378616 C83.4754611,21.647336 83.7597711,21.2475894 83.8025,20.79 L84.7025,11.6325 C84.9886529,8.96981343 84.1121419,6.31312506 82.2976651,4.34349119 C80.4831884,2.37385733 77.9071751,1.28279359 75.23,1.35 L75.23,1.35 Z"
                  class="fill-white"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M75.23,1.35 C74.2436357,1.37082653 73.3619704,1.97035888 72.98,2.88 C73.6224309,3.80249583 73.9962988,4.88515507 74.06,6.0075 C74.1472542,7.94228766 73.7037591,9.86410002 72.7775,11.565 C72.7775,13.4325 78.425,19.2825 81.7775,21.7125 C82.150804,21.9805633 82.6390073,22.0283872 83.0572342,21.8378616 C83.4754611,21.647336 83.7597711,21.2475894 83.8025,20.79 L84.7025,11.6325 C84.9886529,8.96981343 84.1121419,6.31312506 82.2976651,4.34349119 C80.4831884,2.37385733 77.9071751,1.28279359 75.23,1.35 L75.23,1.35 Z"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M67.67,-2.84486309e-05 C71.051685,-0.00994894162 73.8682903,2.59074929 74.1275,5.9625 C74.735,19.305 51.3575,23.3775 48.725,18.1125 C47.5775,15.8625 48.5225,12.33 51.65,12.735 C51.8787995,12.7489794 52.1023347,12.6625729 52.2622467,12.4983389 C52.4221588,12.334105 52.5025746,12.1083455 52.4825,11.88 C52.01,4.77 59.03,-2.84486309e-05 67.67,-2.84486309e-05 Z"
                  class="fill-white"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M67.67,-2.84486309e-05 C71.051685,-0.00994894162 73.8682903,2.59074929 74.1275,5.9625 C74.735,19.305 51.3575,23.3775 48.725,18.1125 C47.5775,15.8625 48.5225,12.33 51.65,12.735 C51.8787995,12.7489794 52.1023347,12.6625729 52.2622467,12.4983389 C52.4221588,12.334105 52.5025746,12.1083455 52.4825,11.88 C52.01,4.77 59.03,-2.84486309e-05 67.67,-2.84486309e-05 Z"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <polygon
                  id="Path"
                  class="fill-white"
                  fill-rule="nonzero"
                  points="53.4275 93.195 58.6025 141.075 76.715 141.075 81.89 93.195" />
                <polygon
                  id="Path"
                  class="fill-white"
                  fill-rule="nonzero"
                  points="78.2675 126.855 81.89 93.195 53.4275 93.195 57.0725 126.855" />
                <line
                  id="Path"
                  x1="67.67"
                  y1="100.98"
                  x2="67.67"
                  y2="141.075"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <line
                  id="Path"
                  x1="57.0725"
                  y1="126.855"
                  x2="78.2675"
                  y2="126.855"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <polygon
                  id="Path"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  points="53.4275 93.195 58.6025 141.075 76.715 141.075 81.89 93.195" />
                <path
                  id="Path"
                  d="M67.67,45.3375 C54.8086689,45.3375 44.3825,55.7636689 44.3825,68.625 L44.3825,73.8 C44.384308,79.2163938 48.1104048,83.9205911 53.3825,85.1625 L53.3825,93.2175 L81.89,93.2175 L81.89,85.1625 C87.1620952,83.9205911 90.888192,79.2163938 90.89,73.8 L90.89,68.625 C90.89,55.7899832 80.5049629,45.3747029 67.67,45.3375 L67.67,45.3375 Z"
                  class="fill-light"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M67.67,45.3375 C54.8086689,45.3375 44.3825,55.7636689 44.3825,68.625 L44.3825,73.8 C44.384308,79.2163938 48.1104048,83.9205911 53.3825,85.1625 L53.3825,93.2175 L81.89,93.2175 L81.89,85.1625 C87.1620952,83.9205911 90.888192,79.2163938 90.89,73.8 L90.89,68.625 C90.89,55.7899832 80.5049629,45.3747029 67.67,45.3375 L67.67,45.3375 Z"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M67.67,53.1000121 C71.4442847,53.0880755 74.6629982,50.3630879 75.2975,46.6425 C70.3612562,44.9030457 64.9787438,44.9030457 60.0425,46.6425 C60.6598167,50.3728674 63.8889054,53.1066386 67.67,53.1000121 L67.67,53.1000121 Z"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M53.4275,85.1625 C54.2772578,85.3510579 55.1445934,85.4491046 56.015,85.455 L61.19,85.455 L61.19,76.5 L56.015,76.5 C54.5859632,76.5 53.4275,75.3415368 53.4275,73.9125 L53.4275,64.9125"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M61.19,85.5 L61.19,76.5 L65.69,76.5 C68.1752814,76.5 70.19,78.5147186 70.19,81 C70.19,83.4852814 68.1752814,85.5 65.69,85.5 L61.19,85.5 Z"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M81.89,85.1625 C81.0404686,85.3524106 80.1729879,85.4504736 79.3025,85.455 L74.1275,85.455 L74.1275,76.5 L79.3025,76.5 C79.9905884,76.5060628 80.6522576,76.2353993 81.1388285,75.7488285 C81.6253993,75.2622576 81.8960628,74.6005884 81.89,73.9125 L81.89,64.9125"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M74.1275,85.5 L74.1275,76.5 L69.6275,76.5 C67.1422186,76.5 65.1275,78.5147186 65.1275,81 C65.1275,83.4852814 67.1422186,85.5 69.6275,85.5 L74.1275,85.5 Z"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M81.1925,141.075 C82.0814986,141.055225 82.898064,140.580344 83.3548912,139.817442 C83.8117184,139.054541 83.8448014,138.110509 83.4425,137.3175 C82.0828508,134.85955 79.501401,133.32789 76.6925,133.312467 L75.5,133.312467 C73.4394238,133.306501 71.4615143,134.122407 70.0044607,135.579461 C68.5474072,137.036514 67.7315012,139.014424 67.7374672,141.075 L81.1925,141.075 Z"
                  class="stroke fill-light"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M67.67,141.075 C67.67,139.016257 66.8521675,137.041835 65.3964164,135.586084 C63.9406653,134.130332 61.966243,133.3125 59.9075,133.3125 L58.6025,133.3125 C55.793599,133.32789 53.2121492,134.85955 51.8525,137.3175 C51.4501986,138.110509 51.4832816,139.054541 51.9401088,139.817442 C52.396936,140.580344 53.2135014,141.055225 54.1025,141.075 L67.67,141.075 Z"
                  class="stroke fill-light"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
